import { render } from "./legacySold.vue?vue&type=template&id=1b843f9c&scoped=true"
import script from "./legacySold.vue?vue&type=script&lang=js"
export * from "./legacySold.vue?vue&type=script&lang=js"

import "./legacySold.vue?vue&type=style&index=0&id=1b843f9c&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b843f9c"]])

export default __exports__